import { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAccount } from '../Context/AccountProvider';
import { useLayout } from '../Context/LayoutProvider';

function StaffPageWrapper({ component: Component, routeProps }) {
    const { setFullWidth, setHideBanner } = useLayout();
    useEffect(() => {
        setFullWidth(true);
        setHideBanner(true);
        return () => { setFullWidth(false); setHideBanner(false); };
    }, [setFullWidth, setHideBanner]);
    return <Component {...routeProps} />;
}

export function StaffRoute({ component: Component, ...rest }) {
    const { accountInfo } = useAccount();

    return (
        <Route {...rest} render={(props) => {
            if (accountInfo.loading) {
                return <div className="white center">Loading...</div>;
            }
            if (!accountInfo.loggedIn || !accountInfo.user?.serverStaff) {
                return <Redirect to="/" />;
            }
            return <StaffPageWrapper component={Component} routeProps={props} />;
        }} />
    );
}
